"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlFormat = UrlFormat;

var _react = _interopRequireDefault(require("react"));

var _controlLink = _interopRequireDefault(require("@eig-builder/control-link"));

function UrlFormat(params) {
  var value = params.value;
  return /*#__PURE__*/_react["default"].createElement(_controlLink["default"], {
    to: "//".concat(value),
    external: true,
    tag: "data-table-url-link"
  }, value);
}